const MuiTablePagination = {
  actions: {
    color: 'white'
  }
};

export default MuiTablePagination;
